import { render, staticRenderFns } from "./deliveryOrderSet.vue?vue&type=template&id=230a700a&scoped=true"
import script from "./deliveryOrderSet.vue?vue&type=script&lang=js"
export * from "./deliveryOrderSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a700a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230a700a')) {
      api.createRecord('230a700a', component.options)
    } else {
      api.reload('230a700a', component.options)
    }
    module.hot.accept("./deliveryOrderSet.vue?vue&type=template&id=230a700a&scoped=true", function () {
      api.rerender('230a700a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/deliveryOrderSet.vue"
export default component.exports